export default __webpack_public_path__ + "static/media/decible_im1.5f0e4dcf.jpg";